import { Box, Button, Grid } from "@mui/material";
import {
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedCheckboxRHF,
    EnhancedDropDownRHFWithLabel,
    EnhancedTextAreaFieldRHF,
    LabelPosition,
    RHookFormDatePicker,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface IVendorPaymentInfoSetupFieldsPanel {
    isExporting: boolean;
    employeeDDL: any;
    handleImportClick: (tag: string) => void
    formMethods: any;
    exportDataPageName: any;
}

export const VendorPaymentInfoSetupFieldsPanel: FC<
    IVendorPaymentInfoSetupFieldsPanel
> = ({ employeeDDL, isExporting, handleImportClick, formMethods, exportDataPageName }) => {
    const currentYear = new Date().getFullYear();

    useEffect(() => {

        formMethods.reset({
            ...formMethods.getValues(),

            stDate: new Date(currentYear, 0, 1),
            enDate: new Date(),
        });

    }, [])
    return (
        <>
            <Box
                sx={{
                    "& .MuiFormControlLabel-root": {
                        marginBottom: "0!important",
                        color: "rgba(0, 0, 0, 0.6)",
                        fontSize: "0.875rem"
                    },
                    "& .MuiFormControlLabel-root .MuiTypography-root": {
                        fontSize: "0.875rem",
                    },
                    "& .enhanced-button": {
                        marginTop: "2rem",
                    }
                }}>

                <Grid
                    container
                    spacing={2}
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                >
                    <Grid
                        size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
                        sx={{
                            "& .MuiBox-root": {
                                paddingTop: "3px !important",
                            },
                            "& .calenderWrapper": {
                                width: "100% !important",
                                minWidth: "unset !important",
                            },
                        }}
                    >
                        <RHookFormDatePicker
                            name="startDate"
                            testId="start-date"
                            label="From"
                            format="M dd, yy"
                            defaultValue={new Date(currentYear, 0, 1)}
                        />
                    </Grid>

                    <Grid
                        size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
                        sx={{
                            "& .MuiBox-root": {
                                paddingTop: "3px !important",
                            },
                            "& .calenderWrapper": {
                                // marginTop: "19px !important",
                                marginBottom: "0 !important",
                                width: "100% !important",
                                minWidth: "unset !important",
                            },
                        }}
                    >
                        <RHookFormDatePicker
                            name="endDate"
                            testId="end-date"
                            label="To"
                            format="M dd, yy"
                            defaultValue={new Date()}
                        />
                    </Grid>
                </Grid>

                <RHookFormDatePicker
                    name="dueDate"
                    testId="due-date"
                    label="Due Date"
                    labelPosition={LabelPosition.Top}
                    format="M dd, yy"
                    labelColumns={4}
                    fieldColumns={8}
                />

                <RHookFormTextFieldWithLabel
                    label="G/L Reference"
                    id="glReference"
                    testId={`gl-reference`}
                    labelPosition={LabelPosition.Top}
                />
                <EnhancedTextAreaFieldRHF
                    label="Memo"
                    id="memo"
                    testId={`memo`}
                    labelPosition={LabelPosition.Top}
                />

                <EnhancedCheckboxRHF
                    name="checkNoInMemo"
                    checked={false}
                    testId="Cheque-No-in-Memo"
                    checkboxLabel="Cheque No in Memo."
                />
                <EnhancedCheckboxRHF
                    name="AccountDescriptionInDescriptionField"
                    checked={false}
                    testId="Account-description-in-description-field"
                    checkboxLabel="Account description in description field"
                />
                <EnhancedCheckboxRHF
                    name="notesInDescriptionFieldWithPaymentEntry"
                    checked={false}
                    testId="notes-In-Description-Field-With-Payment-Entry"
                    checkboxLabel="Notes in description field with payment entry"
                />

                <EnhancedButtonPrimeReact
                    label={exportDataPageName === "quick_books" ? "Export to QuickBooks" : "Export"}
                    // type="submit"
                    raised
                    severity={EnhancedButtonPrimeReactSeverity.Secondary}
                    loading={isExporting}
                    onClickHandler={() => handleImportClick("vendor_payments")}
                />
            </Box>
        </>
    );
};
